module.exports = __webpack_public_path__ + "teacherlaura.jpg?efe0fca4619735fa32a3b804053ff01a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projetos/teacherlaura.jpg
// module id = 157
// module chunks = 0